<template>
	<div>
		<v-sheet color="#f5f5f5" class="py-15 px-5">
			<v-container>
				<v-row>
					<v-col cols="12" md="3" lg="3"></v-col>
					<v-col cols="12" md="9" lg="9">
						<div class="line-title">
							<span class="text">طرح های ما</span>
							<span class="line"></span>
						</div>
					</v-col>
				</v-row>
				<v-row>
					<v-col cols="12" md="3" lg="3">
						<v-card>
							<v-card-title>
								<h4 class="text-h4">
									فیلترها
								</h4>
							</v-card-title>
							<v-card-text>
								<div class="filter-section">
									<v-checkbox v-model="filter.nonProfit" label="بدون سود" color="secondary" hide-details class="my-0 py-0 small"></v-checkbox>
									<v-checkbox v-model="filter.lessThanOneProfit" label="کمتر از 1 درصد بهره" color="secondary" hide-details class="my-0 py-0 small"></v-checkbox>
									<v-checkbox v-model="filter.betweenOneTwoProfit" label="بین 1 تا 2 درصد بهره" color="secondary" hide-details class="my-0 py-0 small"></v-checkbox>
									<v-checkbox v-model="filter.moreThanTwoProfit" label="بیش از 2 درصد بهره" color="secondary" hide-details class="my-0 py-0 small"></v-checkbox>
								</div>
								<div class="filter-section">
									<v-checkbox v-model="filter.nonDelay" label="بدون جریمه دیرکرد" color="secondary" hide-details class="my-0 py-0 small"></v-checkbox>
									<v-checkbox v-model="filter.hasEarly" label="دارای سود زودکرد" color="secondary" hide-details class="my-0 py-0 small"></v-checkbox>
								</div>
								<div class="filter-section">
									<v-checkbox v-model="filter.nonMax" label="بدون سقف وام" color="secondary" hide-details class="my-0 py-0 small"></v-checkbox>
									<v-checkbox v-model="filter.hasMax" label="دارای سقف وام" color="secondary" hide-details class="my-0 py-0 small"></v-checkbox>
								</div>
								<div class="filter-section">
									<v-checkbox v-model="filter.allowedInstallments" label="دوره بازپرداخت دلخواه" color="secondary" hide-details class="my-0 py-0 small"></v-checkbox>
									<v-checkbox v-model="filter.notAllowedInstallments" label="دوره بازپرداخت محدود" color="secondary" hide-details class="my-0 py-0 small"></v-checkbox>
								</div>
								<div class="filter-section">
									<v-checkbox v-model="filter.notDisable" label="طرح های فعال" color="secondary" hide-details class="my-0 py-0 small"></v-checkbox>
								</div>
							</v-card-text>
						</v-card>
					</v-col>
					<v-col cols="12" md="9" lg="9">
						<div style="position: relative" class="mx-auto mb-5">
							<div class="mt- mb-7">
								<div v-if="loanLoading" class="success--text text-h4 text-center">
									در حال دریافت اطلاعات ...
								</div>
								<v-alert outlined dense v-if="loans.length == 0 && !loanLoading" type="error">
									در حال حاضر طرح وام فعالی وجود ندارد
								</v-alert>
								<v-row v-else-if="!loanLoading">
									<v-alert outlined dense v-if="filteredLoans.length == 0" type="error">
										طرحی یافت نشد.
									</v-alert>
									<v-col cols="12" md="4" v-else v-for="loan in filteredLoans" :key="loan.id">
										<router-link :to="`/cl/plan/${customerCode}/${loan.code}/${loan.title}`" style="text-decoration: none;">
											<v-card elevation="0" class="rounded-lg pa-2" color="#f2efe8">
												<div class="text-center pt-2 d-flex justify-center">
													<v-img v-if="loan.base64" :src="loan.base64" width="135px" />
													<v-icon v-else size="100" color="grey">mdi-account-cash</v-icon>
												</div>
												<v-sheet class="pa-1 rounded-md" color="white" height="90px" style="height: 90px;">
													<div class="text-right pa-2" style="overflow: hidden;height: 60px;">{{ loan.planTitle }}</div>
													<div class="d-flex flex-wrap">
														<v-chip class="mx-2" color="#e7fee8" x-small v-if="!loan.profitPercent">بدون سود</v-chip>
														<v-chip class="mx-2" color="#e7fee8" x-small v-else>سود: {{ loan.profitPercent }}</v-chip>
														<v-chip class="mx-2" color="#e7fee8" x-small v-if="!loan.delayPercent">بدون جریمه</v-chip>
														<v-chip class="mx-2" color="#e7fee8" x-small v-if="!!loan.earlyPercent">سود زودکرد</v-chip>
														<v-chip class="mx-2" color="#e7fee8" x-small v-if="!loan.maxAmount">بدون سقف</v-chip>
														<v-chip class="mx-2" color="#e7fee8" x-small v-if="!loan.allowedInstallments">بازپرداخت دلخواه</v-chip>
														<v-chip class="mx-2" color="#ffccdd" x-small v-if="loan.disable">غیر فعال</v-chip>
													</div>
												</v-sheet>
											</v-card>
										</router-link>
									</v-col>
									<v-overlay :absolute="true" :value="overlayLoading">
										<v-progress-circular :size="50" :width="7" color="purple" indeterminate></v-progress-circular>
									</v-overlay>
								</v-row>
							</div>

						</div>
					</v-col>
				</v-row>
			</v-container>
		</v-sheet>
	</div>
</template>

<script>
	import { get } from 'vuex-pathify'
	import api from '@/util/app-api'
	import toast from '@/util/toast'
	import router from '@/router'
	import _ from 'lodash'

	export default {
		name: 'PlansView',
		components: {
			'loan-calculator': () => import('@/components/LoanCalculator'),
		},
		data: () => ({
			loanRequest: { amount: 10000000, installmentCount: 1, monthGap: 1, loanModel: null },
			customerCode: 0,
			filter: {
				nonProfit: false,
				lessThanOneProfit: false,
				betweenOneTwoProfit: false,
				moreThanTwoProfit: false,
				nonDelay: false,
				hasEarly: false,
				nonMax: false,
				hasMax: false,
				allowedInstallments: false,
				notAllowedInstallments: false,
				notDisable: false
			},
			overlayLoading: false,
			loans: [],
			loanLoading: false,
			submitRequestLoading: false,
			loanRequestMessage: ''
		}),
		computed: {
			...get('auth', [
				'isMember', 'getCurrentUser'
			]),
			authorizations() {
				return this.loanRequest.loanModel?.loanAuthorizationItems || []
			},
			filteredLoans() {
				let items = _.cloneDeep(this.loans)

				this.overlayLoading = true
				this.overlayLoading = false
				let conditions = []

				if (this.filter.nonProfit)
					conditions.push((loan) => !loan.profitPercent)

				if (this.filter.lessThanOneProfit)
					conditions.push((loan) => loan.profitPercent <= 1)

				if (this.filter.betweenOneTwoProfit)
					conditions.push((loan) => loan.profitPercent >= 1 && loan.profitPercent <= 2)

				if (this.filter.moreThanTwoProfit)
					conditions.push((loan) => loan.profitPercent >= 2)

				if (conditions.length)
					items = items.filter(item => conditions.some(c => c(item)))

				//////
				conditions = []
				if (this.filter.nonDelay)
					conditions.push((loan) => !loan.delayPercent)

				if (this.filter.hasEarly)
					conditions.push((loan) => !!loan.earlyPercent)

				if (conditions.length)
					items = items.filter(item => conditions.some(c => c(item)))

				/////
				conditions = []
				if (this.filter.nonMax)
					conditions.push((loan) => !loan.maxAmount)

				if (this.filter.hasMax)
					conditions.push((loan) => !!loan.maxAmount)

				if (conditions.length)
					items = items.filter(item => conditions.some(c => c(item)))

				//////
				conditions = []
				if (this.filter.allowedInstallments)
					conditions.push((loan) => !loan.allowedInstallments)

				if (this.filter.notAllowedInstallments)
					conditions.push((loan) => !!loan.allowedInstallments)

				if (conditions.length)
					items = items.filter(item => conditions.some(c => c(item)))

				//////
				conditions = []
				if (this.filter.notDisable)
					conditions.push((loan) => !loan.disable)

				if (conditions.length)
					items = items.filter(item => conditions.some(c => c(item)))

				return items
			}
		},
		mounted() {
			this.customerCode = this.$route.params.customerCode || 0
			this.loadLoans()
		},
		methods: {
			loadLoans() {
				this.loanLoading = true
				return api.get('loan/list/' + this.customerCode + '/true', null, { authHeader: false, contentType: 'application/json' })
					.then(
						response => {
							this.loans = response
						})
					.catch(err => {
						toast.error(err.message)
					})
					.finally(() => {
						this.loanLoading = false
					})
			},
			submitRequest() {
				if (!this.loanRequest.loanModel) {
					this.loanRequestMessage = 'ابتدا طرح وام را انتخاب کنید.'
					return
				}
				if (!this.isMember) {
					router.push({ name: 'Register', params: { customerCode: this.customerCode } }).catch(() => { })
					return
				}
				this.submitRequestLoading = true
				this.loanRequestMessage = ''
				api.post('member/userLoanRequest/create', this.loanRequest)
					.then(response => {
						router.replace('/member/LoanRequest/' + response).catch(() => { })
					})
					.catch(err => {
						this.loanRequestMessage = err.message
					})
					.finally(() => {
						this.submitRequestLoading = false
					})
			},
			selectLoan(loan) {
				this.loanRequest.loanModel = loan
			},
			scrollToCalculator() {
				document.getElementById("calculator").scrollIntoView()
			}
		},
	}
</script>

<style lang="scss">
	.landing {
		.fs-h1 {
			font-size: 3.3125rem !important;
		}

		.fs-h2 {
			font-size: 2.25rem !important;
		}

		.fs-h3 {
			font-size: 1.5625rem !important;
		}

		.fs-h4 {
			font-size: 1.125rem !important;
		}

		.fs-h5 {
			font-size: 1.0625rem !important;
		}

		.fs-h6 {
			font-size: 0.75rem !important;
		}

		.fs-subtitle-1 {
			font-size: 0.875rem !important;
		}

		.fs-subtitle-2 {
			font-size: 0.875rem !important;
		}

		.fs-caption {
			font-size: 0.8125rem !important;
		}
	}

	.section-title {
		position: relative;
		margin-right: 38px;

		&:before {
			position: absolute;
			bottom: 5px;
			right: -40px;
			content: "";
			width: 30px;
			height: 60px;
			background-image: radial-gradient(#bbb 2px, transparent 2px);
			-webkit-background-size: 20px 20px;
			background-size: 10px 10px;
			border-radius: 0px;
			background-repeat: initial;
		}
	}

	.line-title {
		position: relative;
		display: flex;

		.line {
			position: relative;
			flex-grow: 2;

			&:after {
				position: absolute;
				content: " ";
				background-color: #cdcdcd47;
				height: 2px;
				right: 0;
				left: 0;
				top: 25px;
			}
		}

		.text {
			padding-left: 20px;
			font-size: 2.25rem !important;
			color: orange;
			font-family: "Emkan-Bold", "Yekan", "tahoma";
		}

		&:after {
			height: 2px;
			width: 50px;
			content: "";
			position: absolute;
			left: 0;
			height: 2px;
			top: 46%;
			background-color: orange;
		}
	}

	.price-table {
		background-color: #f1f1f1;
		position: relative;

		.price-table__ribbon {
			position: absolute;
			top: 0;
			left: 0;
			right: auto;
			-webkit-transform: rotate(0);
			-ms-transform: rotate(0);
			transform: rotate(0);
			width: 150px;
			overflow: hidden;
			height: 150px;

			.price-table__ribbon-inner {
				background-color: orange;
				color: #ffffff;
				font-weight: 500;
				text-align: center;
				left: 0;
				width: 200%;
				-webkit-transform: translateY(-50%) translateX(0) translateX(35px) rotate(-45deg);
				-ms-transform: translateY(-50%) translateX(0) translateX(35px) rotate(-45deg);
				transform: translateY(-50%) translateX(0) translateX(35px) rotate(-45deg);
				margin-top: 35px;
				font-size: 13px;
				line-height: 2;
			}
		}

		.header {
			background-color: #4d306e;
			text-align: center;
			padding: 20px;

			.title-1 {
				font-size: 1.4rem;
				font-weight: bold;
				color: white;
			}

			.title-2 {
				font-size: 0.9rem;
				color: white;
			}
		}

	}

	.filter-section {
		border-bottom: 1px dashed #ddd;
		margin-bottom: 10px;
		padding-bottom: 10px;
	}

	.v-input--checkbox.small label {
		font-size: 14px;
	}
</style>